import { inject, Component, OnInit } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';

import { AppService } from '../app.service';
import { MessageService } from '../message.service';

@Component({
    selector: 'app-app-upload',
    templateUrl: './app-upload.component.html',
    styleUrls: ['./app-upload.component.scss'],
    standalone: true,
    imports: [RouterModule, ReactiveFormsModule]
})
export class AppUploadComponent implements OnInit {

  uploadForm: UntypedFormGroup;

  private appService: AppService = inject(AppService);
  private formBuilder: UntypedFormBuilder = inject(UntypedFormBuilder);
  private messageService: MessageService = inject(MessageService);
  private router: Router = inject(Router);

  constructor() {
    this.uploadForm = this.formBuilder.group({
      file: ''
    });
  }

  ngOnInit(): void {
    this.messageService.clear();
  }

  onFileSelect(event) {
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      this.uploadForm.get('file').setValue(file);
    }
  }

  onSubmit(): void {
    this.messageService.set(`Deploying app...`);
    const formData = new FormData();
    formData.append('file', this.uploadForm.get('file').value);


    this.appService
      .upload(formData)
      .subscribe(app => {
        this.router.navigate(['/apps']);
      });
  }

}
